<style lang="scss" scoped>
.query-form-div {
  padding: 12px;
}

.body-div {
  padding: 0 12px;
}

.pagination-div {
  padding: 12px;
  text-align: right;
}

.handle-div {
  padding: 12px;
  text-align: right;
}

i {
  cursor: pointer;
  margin: 0 5px;
  font-size: 16px;
}

.el-icon-delete {
  color: red;
}
</style>
<template>
  <div v-loading="allLoading" element-loading-text="数据加载中...">
    <div class="query-form-div">
      <el-form :inline="true" :model="queryForm">
        <el-form-item label="赛事名称">
          <el-input size="small" v-model="queryForm.MatchName" placeholder="赛事名称" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" icon="el-icon-search" :loading="allLoading"
            @click="query(true)">查询</el-button>
          <el-button type="default" size="small" icon="el-icon-plus" @click="toEditMatchPage('')">添加赛事</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="body-div">
      <el-table :data="table.data" style="width: 100%" stripe border size="mini">
        <el-table-column label="赛事名称(简称)" >
          <template slot-scope="scope">
            <span style="cursor: pointer;color: #3798ed ;text-decoration: underline"
              @click="toEditMatchPage(scope.row.MatchId)">{{ scope.row.MatchName
              }}({{ scope.row.MatchSimpleName }})</span>
          </template>
        </el-table-column>
        <el-table-column label="报名时间" prop="MatchSignUpTime" width="200px" align="center">
          <template slot-scope="scope">
            <div>开始时间:{{ scope.row.SignUpStartTime }}</div>
            <div>结束时间:{{ scope.row.SignUpEndTime }}</div>
          </template>
        </el-table-column>
        <el-table-column label="比赛时间" prop="MatchTime" width="200px" align="center">
          <template slot-scope="scope">
            <div>开始时间:{{ scope.row.StartTime }}</div>
            <div>结束时间:{{ scope.row.EndTime }}</div>
          </template>
        </el-table-column>
      
        <el-table-column label="举办地点" prop="MatchAddress" width="150px" />
        <el-table-column label="报名人数" prop="SignUpNum" width="100px" align="center" />
        <el-table-column label="成绩二维码" width="100px" align="center">
          <template v-slot="scope">
            <i class="el-icon-erweima" @click="showQrc(scope.row)"></i>
          </template>
        </el-table-column>
        <el-table-column label="添加人" prop="CreateAccountName" width="100px" align="center" />
          <el-table-column label="报名状态" prop="MatchSignStatusSwitch" width="100px" align="center">
          <template v-slot="scope">
            <el-switch v-model="scope.row.MatchSignStatusSwitch" @change="changeMatchSignStatus(scope.row)"
              active-color="#13ce66" inactive-color="#999">
            </el-switch>
            <!-- <el-tag size="mini" type="danger" v-if="scope.row.SignUpStatus == 2 || scope.row.SignUpStatus == 3">{{
              scope.row.SignUpStatusText }}</el-tag>
            <el-tag size="mini" type="success" v-if="scope.row.SignUpStatus == 1">{{ scope.row.SignUpStatusText
            }}</el-tag>
            <el-tag size="mini" type="info" v-if="scope.row.SignUpStatus == 0">{{ scope.row.SignUpStatusText }}</el-tag> -->
          </template>
        </el-table-column>
        <el-table-column label="比赛状态" prop="MatchStatusText" width="100px" align="center">
          <template v-slot="scope">
            <el-switch v-model="scope.row.MatchStatusSwitch" @change="changeMatchStatus(scope.row)"
              active-color="#13ce66" inactive-color="#999">
            </el-switch>
            <!-- <el-tag size="mini" type="info" v-if="scope.row.MatchStatus == 0">{{ scope.row.MatchStatusText }}</el-tag>
            <el-tag size="mini" type="success" v-if="scope.row.MatchStatus == 1">{{ scope.row.MatchStatusText
            }}</el-tag>
            <el-tag size="mini" type="danger" v-if="scope.row.MatchStatus == 2">{{ scope.row.MatchStatusText }}</el-tag> -->
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200px">

          <template slot-scope="scope">
            <!-- <span v-if="scope.row.SignUpStatus != 1" style="cursor: pointer;"
              @click="setMatchStatus(scope.row.MatchId, 'StartSignUp')">开启报名</span>
            <span style="color: red;cursor: pointer;" v-if="scope.row.MatchStatus == 0 && scope.row.SignUpStatus == 1"
              @click="setMatchStatus(scope.row.MatchId, 'EndSignUp')">截止报名</span>
            <span style="color: green;padding: 0 5px;cursor: pointer;" v-if="scope.row.MatchStatus == 0"
              @click="setMatchStatus(scope.row.MatchId, 'StartMatch')">开始比赛</span>
            <span style="color: red;padding: 0 5px;cursor: pointer;" v-if="scope.row.MatchStatus == 1"
              @click="setMatchStatus(scope.row.MatchId, 'EndMatch')">结束比赛</span> -->
              <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteMatch(scope.row)" circle></el-button>
              <el-button  size="mini" icon="el-icon-gongzuozheng" @click="toGenerateCompetitionPass(scope.row)" circle></el-button>
            <el-dropdown @command="handleExportCommand" style="margin-left: 5px;" size="mini">
              <el-button type="primary" size="mini" icon="el-icon-more" round>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="'pps_' + scope.row.MatchId">项目人数统计表</el-dropdown-item>
                <el-dropdown-item :command="'mps_' + scope.row.MatchId">参赛人数统计表</el-dropdown-item>
                <el-dropdown-item :command="'un_' + scope.row.MatchId">代表队名单</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-div">
      <el-pagination background :current-page="table.pageIndex" :page-sizes="[10, 20, 40, 60, 100]"
        :page-size="table.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="table.total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>


    <el-dialog title="二维码" :visible.sync="qrcodeDialogVisible" width="500px" center>
      <div class="qrcode-container" style="text-align: center;">
        <img :src="qrcodeUrl" alt="二维码" style="max-width: 100%;">
      </div>
      <div style="text-align: center; margin-top: 15px;">
        <el-button type="primary" size="small" @click="downloadQrcode">下载二维码</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MatchService from "@/request-server/request-services/match-services.js";
import Common from "@/utils/utils-common.js";
import QRCode from 'qrcode';
import Url from '../../../request-server/request-url';
export default {
  data() {
    return {
      queryForm: {
        MatchName: '',
      },
      qrcodeUrl: '',
      qrcodeDialogVisible: false,
      allLoading: false,
      table: {
        data: [],
        total: 0,
        pageIndex: 1,
        pageSize: 10
      }
    }
  },
  created() {
    this.query(true);
  },
  methods: {
    query(isInfo = true) {
      if (isInfo) {
        this.table.pageIndex = 1;
      }
      this.getMatchList();
    },
    handleSizeChange(val) {
      this.table.pageSize = val;
      this.getMatchList();
    },
    handleCurrentChange(index) {
      this.table.pageIndex = index;
      this.getMatchList();
    },
    async showQrc(row) {
      try {
        // 假设需要将row的某些数据转换为二维码
        const data = 'http://wap.jianyuesports.com/#/pages/match-rank/match-rank?matchId=' + row.MatchId;

        // 生成二维码
        this.qrcodeUrl = await QRCode.toDataURL(data, {
          width: 1000,
          margin: 2,
          color: {
            dark: '#000000',  // 二维码颜色
            light: '#ffffff'  // 背景色
          }
        });

        this.qrcodeDialogVisible = true;
      } catch (err) {
        this.$message.error('生成二维码失败');
        console.error(err);
      }
    },
    changeMatchStatus(row) {
      console.log(row)
      let status = row.MatchStatusSwitch ? 'StartMatch' : 'EndMatch';
     
      MatchService.setMatchStatus({ matchId: row.MatchId, status: status }).then(res => {
        if (res.code == 0) {
          this.$message.success(res.data);
          this.query(false);
        }
      }).finally(()=>{
        this.query(false);
      })
    },
    changeMatchSignStatus(row) {
      console.log(row)
      let status = row.MatchSignStatusSwitch ? 'StartSignUp' : 'EndSignUp';
     
      MatchService.setMatchStatus({ matchId: row.MatchId, status: status }).then(res => {
        if (res.code == 0) {
          this.$message.success(res.data);
          this.query(false);
        }
      }).finally(() => {
        this.query(false);
      })
    },
    getMatchList() {
      let data = {
        PageIndex: this.table.pageIndex,
        PageSize: this.table.pageSize,
        Where: {
          MatchName: this.queryForm.MatchName,
        }
      }
      this.allLoading = true;
      MatchService.selectMatchList(data).then(res => {
        this.allLoading = false;
        console.log(res)
        if (res.code == 0) {
          this.table.data = res.data.Data;
          this.table.total = res.data.TotalRow;
        }
      })
    },
    clearDateT(row, column, cellValue) {
      return cellValue.replace('T', ' ');
    },

    deleteMatch(row) {
      this.$confirm('确定删除赛事吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        MatchService.delMatch({ MatchId: row.MatchId }).then(res => {
          if (res.code == 0) {
            this.$message.success('删除成功');
            this.query(false);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })
    },
    toGenerateCompetitionPass(row){
      this.$router.push({
        path: '/mainpage/match-competition-pass/' + row.MatchId
      })
    },
    handleExportCommand(command) {
      let type = command.split('_')[0];
      let id = command.split('_')[1];
      if (type == 'pps') {
        MatchService.exportMatchProjectSignUpNumber({ matchId: id }).then(resData => {
          if (resData.code == 0) {
            this.$message.success('导出成功');
            location.href = Url.getDownloadBaseUrl() + '/exportfiles/' + resData.data;
          }
        })
      } else if (type == 'mps') {
        MatchService.exportMatchUnitAttendanceNumber({ matchId: id }).then(resData => {
          if (resData.code == 0) {
            this.$message.success('导出成功');
            location.href = Url.getDownloadBaseUrl() + '/exportfiles/' + resData.data;
          }
        })
      } else if (type == 'un') {
        MatchService.exportMatchUnitTeamRoster({ matchId: id }).then(resData => {
          if (resData.code == 0) {
            this.$message.success('导出成功');
            location.href = Url.getDownloadBaseUrl() + '/exportfiles/' + resData.data;
          }
        })
      }
    },
    setMatchStatus(matchId, status) {
      let text = "";
      switch (status) {
        case 'StartMatch':
          text = '是否确认要开始比赛？开始比赛后将会截止报名'
          break;
        case 'EndMatch':
          text = '是否确认要结束比赛？'
          break;
        case 'StartSignUp':
          text = '是否确认要开启报名？'
          break;
        case 'EndSignUp':
          text = '是否确认要截止报名？'
          break;
      }


      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        MatchService.setMatchStatus({ matchId: matchId, status: status }).then(res => {
          if (res.code == 0) {
            this.$message.success(res.data);
            this.query(false);
          }
        })
      }).catch(() => {

      })
    },
    toEditMatchPage(id) {
      this.$store.commit("matchIdCookie", id);
      this.$router.push({ path: '/mainpage/match-edit/' + id });
    },





    downloadQrcode() {
      // 创建一个临时链接
      const link = document.createElement('a');
      link.href = this.qrcodeUrl;
      link.download = '赛事成绩二维码.png';

      // 将链接添加到页面并模拟点击
      document.body.appendChild(link);
      link.click();

      // 清理
      document.body.removeChild(link);
    }
  }
}
</script>

<style lang="scss" scoped></style>
